import { initializeApp, getApps, getApp, type FirebaseApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithPopup } from "firebase/auth";

/**
 * Firebase client (chỉ chạy ở trình duyệt). Config lấy từ biến NEXT_PUBLIC_*
 * (được Next inline vào bundle). Dùng để đăng nhập Google rồi lấy ID token gửi backend.
 */
const config = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
  appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
};

/** Đã cấu hình đủ để bật nút Google chưa (kiểm ở cả server lẫn client). */
export function isFirebaseClientConfigured(): boolean {
  return Boolean(config.apiKey && config.authDomain && config.projectId && config.appId);
}

function getFirebaseApp(): FirebaseApp {
  return getApps().length ? getApp() : initializeApp(config);
}

/**
 * Mở popup đăng nhập Google, trả về Firebase ID token (JWT) để backend verify.
 * Ném lỗi nếu người dùng đóng popup hoặc bị chặn.
 */
export async function signInWithGoogleGetIdToken(): Promise<string> {
  const auth = getAuth(getFirebaseApp());
  auth.useDeviceLanguage();
  const provider = new GoogleAuthProvider();
  provider.setCustomParameters({ prompt: "select_account" });
  const cred = await signInWithPopup(auth, provider);
  return cred.user.getIdToken();
}
